import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CorporateDetailsState {
  company_id: string;
  employee_id_number: string;
  employee_id_card_front_page: string;
}

const initialState: CorporateDetailsState = {
  company_id: '',
  employee_id_number: '',
  employee_id_card_front_page: '',
};

const corporateDetailsSlice = createSlice({
  name: 'corporateDetails',
  initialState,
  reducers: {
    setCorporateDetails: (state, action: PayloadAction<CorporateDetailsState>) => {
      state.company_id = action.payload.company_id;
      state.employee_id_number = action.payload.employee_id_number;
      state.employee_id_card_front_page = action.payload.employee_id_card_front_page;
    },
    resetCorporateDetails: (state) => {
      state.company_id = '';
      state.employee_id_number = '';
      state.employee_id_card_front_page = '';
    },
  },
});

export const { setCorporateDetails, resetCorporateDetails } = corporateDetailsSlice.actions;
export default corporateDetailsSlice.reducer; 